// @ts-nocheck
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InfosBoxComponent, {
    InfosBoxSize,
    infosBoxSizeOptions,
    InfosBoxType,
    infosBoxTypeOptions,
} from "@store/Library/Components/Toolkit/InfosBox";
import { getDataOptionsFieldDefinition } from "@toolkit/Framework/Common/Utilities/dataOptions";
import parse from "html-react-parser";
import React, { FC } from "react";

const enum fields {
    htmlContent = "htmlContent",
    showIcon = "showIcon",
    size = "size",
    type = "type",
}

interface Props extends WidgetProps {
    fields: {
        [fields.htmlContent]: string;
        [fields.showIcon]: boolean;
        [fields.size]: InfosBoxSize;
        [fields.type]: InfosBoxType;
    };
}

const InfosBox: FC<Props> = ({ fields: { htmlContent, showIcon, size, type } }) => {
    return (
        <InfosBoxComponent type={type} showIcon={showIcon} size={size}>
            {parse(htmlContent, parserOptions)}
        </InfosBoxComponent>
    );
};

const widgetModule: WidgetModule = {
    component: InfosBox,
    definition: {
        displayName: "Infos Box",
        group: "Basic",
        icon: "circle-i",
        fieldDefinitions: [
            {
                ...getDataOptionsFieldDefinition(infosBoxTypeOptions),
                name: fields.type,
                displayName: "Type",
                fieldType: "Contextual",
                hideEmptyOption: true,
            },
            {
                ...getDataOptionsFieldDefinition(infosBoxSizeOptions),
                name: fields.size,
                displayName: "Size",
                fieldType: "Contextual",
                hideEmptyOption: true,
            },
            {
                name: fields.showIcon,
                displayName: "Show Icon",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
            },
            {
                name: fields.htmlContent,
                displayName: "Content",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Contextual",
            },
        ],
    },
};

export default widgetModule;
